import httpClient from '@/api/http-client';

const endpoint = 'api/airports';

const airportsService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (search) => httpClient.post(`${endpoint}/find`, { search }),

  update: (airport) => httpClient.put(`${endpoint}/${airport.id}`, airport),
};

export default airportsService;
